import axios from "axios";

const parentApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

parentApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("vlog_parent_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default parentApi;
